module.exports = "<div *ngIf=\"this.loader.getLoading()\" class=\"cssload-container\">\n  <div class=\"cssload-speeding-wheel\"></div>\n</div>"